import { capitalizeFirstLetter } from '@nu-art/ts-common';
export const Renderer_BookFullName = (bookRef, book) => {
    const parts = [book];
    for (let i = 0; i <= bookRef.data.path.length - 1; i++) {
        const pathElement = bookRef.data.path[i];
        parts.push(parts[i].items[pathElement]);
    }
    let str = '';
    parts.forEach((item, i) => {
        //0 reads from book
        if (i === 0) {
            str += book.name.split(' ')[0];
            return;
        }
        const type = parts[i - 1].itemsType;
        if (type)
            str += ` - ${capitalizeFirstLetter(type)} ${(parts[i - 1].items?.findIndex(_item => _item.name === item.name)) + 1}`;
    });
    return str;
};
//# sourceMappingURL=Renderer_BookFullName.js.map